import gql from 'graphql-tag'
export default gql`
query{
    getServiceTypes{
      id
      siteId
      slugName
      displayName
      typeName
      typeDes
      typeStatus
      masterServiceType
      aggregatorMerchantId
      isAggregatorEnabled
      aggregatorSystem
    }
  }`